import actions from "./actions";

const {
  FINANCE_COMPANY_LIST_BEGIN,
  FINANCE_COMPANY_LIST_SUCCESS,
  FINANCE_COMPANY_LIST_ERR,
  FINANCE_COMPANY_LIST_RESET,
  FINANCE_GENERATE_OTP_BEGIN,
  FINANCE_GENERATE_OTP_SUCCESS,
  FINANCE_GENERATE_OTP_ERR,
  FINANCE_GENERATE_OTP_RESET,
  FINANCE_VERIFY_OTP_BEGIN,
  FINANCE_VERIFY_OTP_SUCCESS,
  FINANCE_VERIFY_OTP_ERR,
  FINANCE_VERIFY_OTP_RESET,
  FINANCE_HISTORY_BEGIN,
  FINANCE_HISTORY_SUCCESS,
  FINANCE_HISTORY_ERR,
  FINANCE_HISTORY_RESET,
  FINANCE_VIEW_DETAILS_BEGIN,
  FINANCE_VIEW_DETAILS_SUCCESS,
  FINANCE_VIEW_DETAILS_ERR,
  FINANCE_VIEW_DETAILS_RESET,
  FINANCE_UPDATE_PROOF_DETAILS_BEGIN,
  FINANCE_UPDATE_PROOF_DETAILS_SUCCESS,
  FINANCE_UPDATE_PROOF_DETAILS_ERR,
  FINANCE_UPDATE_PROOF_DETAILS_RESET,
  FINANCE_UPDATE_PRODUCT_PROOF_DETAILS_BEGIN,
  FINANCE_UPDATE_PRODUCT_PROOF_DETAILS_SUCCESS,
  FINANCE_UPDATE_PRODUCT_PROOF_DETAILS_ERR,
  FINANCE_UPDATE_PRODUCT_PROOF_DETAILS_RESET,
} = actions;

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const financeCompanyListReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case FINANCE_COMPANY_LIST_BEGIN:
      return {
        ...initialState,
        loading: true,
      };

    case FINANCE_COMPANY_LIST_SUCCESS:
      return {
        ...initialState,
        data,
        loading: false,
      };

    case FINANCE_COMPANY_LIST_ERR:
      return {
        ...initialState,
        error: err,
        loading: false,
      };

    case FINANCE_COMPANY_LIST_RESET:
      return initialState;

    default:
      return state;
  }
};

export const financeGenerateOtpReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case FINANCE_GENERATE_OTP_BEGIN:
      return {
        ...initialState,
        loading: true,
      };

    case FINANCE_GENERATE_OTP_SUCCESS:
      return {
        ...initialState,
        data,
        loading: false,
      };

    case FINANCE_GENERATE_OTP_ERR:
      return {
        ...initialState,
        error: err,
        loading: false,
      };

    case FINANCE_GENERATE_OTP_RESET:
      return initialState;

    default:
      return state;
  }
};

export const financeVerifyOtpReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case FINANCE_VERIFY_OTP_BEGIN:
      return {
        ...initialState,
        loading: true,
      };

    case FINANCE_VERIFY_OTP_SUCCESS:
      return {
        ...initialState,
        data,
        loading: false,
      };

    case FINANCE_VERIFY_OTP_ERR:
      return {
        ...initialState,
        error: err,
        loading: false,
      };

    case FINANCE_VERIFY_OTP_RESET:
      return initialState;

    default:
      return state;
  }
};

export const financeHistoryReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case FINANCE_HISTORY_BEGIN:
      return {
        ...initialState,
        loading: true,
      };

    case FINANCE_HISTORY_SUCCESS:
      return {
        ...initialState,
        data,
        loading: false,
      };

    case FINANCE_HISTORY_ERR:
      return {
        ...initialState,
        error: err,
        loading: false,
      };

    case FINANCE_HISTORY_RESET:
      return initialState;

    default:
      return state;
  }
};

export const financeViewDetailsReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case FINANCE_VIEW_DETAILS_BEGIN:
      return {
        ...initialState,
        loading: true,
      };

    case FINANCE_VIEW_DETAILS_SUCCESS:
      return {
        ...initialState,
        data,
        loading: false,
      };

    case FINANCE_VIEW_DETAILS_ERR:
      return {
        ...initialState,
        error: err,
        loading: false,
      };

    case FINANCE_VIEW_DETAILS_RESET:
      return initialState;

    default:
      return state;
  }
};

export const financeUpdateProofDetailsReducer = (
  state = initialState,
  action,
) => {
  const { type, data, err } = action;

  switch (type) {
    case FINANCE_UPDATE_PROOF_DETAILS_BEGIN:
      return {
        ...initialState,
        loading: true,
      };

    case FINANCE_UPDATE_PROOF_DETAILS_SUCCESS:
      return {
        ...initialState,
        data,
        loading: false,
      };

    case FINANCE_UPDATE_PROOF_DETAILS_ERR:
      return {
        ...initialState,
        error: err,
        loading: false,
      };

    case FINANCE_UPDATE_PROOF_DETAILS_RESET:
      return initialState;

    default:
      return state;
  }
};

export const financeUpdateProductProofDetailsReducer = (
  state = initialState,
  action,
) => {
  const { type, data, err } = action;

  switch (type) {
    case FINANCE_UPDATE_PRODUCT_PROOF_DETAILS_BEGIN:
      return {
        ...initialState,
        loading: true,
      };

    case FINANCE_UPDATE_PRODUCT_PROOF_DETAILS_SUCCESS:
      return {
        ...initialState,
        data,
        loading: false,
      };

    case FINANCE_UPDATE_PRODUCT_PROOF_DETAILS_ERR:
      return {
        ...initialState,
        error: err,
        loading: false,
      };

    case FINANCE_UPDATE_PRODUCT_PROOF_DETAILS_RESET:
      return initialState;

    default:
      return state;
  }
};
